import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { PlaidLinkTokenCreateRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { PlaidLinkTokenCreateResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const plaidLinkTokenCreate = (request: PlaidLinkTokenCreateRequest, options?: CashRequestOptions) =>
  post<PlaidLinkTokenCreateRequest, PlaidLinkTokenCreateResponse>('/2.0/cash/plaid-link-token-create', request, {
    ...options,
    rejectOnError: true,
  })
